import {
  SET_CURRENT_ORGANIZATION,
  IS_CHANGING_CURRENT_ORGANIZATION,
  IS_NOT_CHANGING_CURRENT_ORGANIZATION
} from '../actions/organization'

const initialState = {
  orgId: null,
  isChangingCurrentOrganization: false
}

export function organization(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        orgId: action.orgId
      })
    case IS_CHANGING_CURRENT_ORGANIZATION:
      return {
        ...state,
        isChangingCurrentOrganization: true
      }

    case IS_NOT_CHANGING_CURRENT_ORGANIZATION:
      return {
        ...state,
        isChangingCurrentOrganization: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organization.js